module.exports = __webpack_public_path__ + "img/quantum-processor.49b79627.png";